import * as React from 'react';
export const useScrollDetection = ({ ref, offset, cb, dep, }) => {
    const currentState = React.useRef(false);
    React.useEffect(() => {
        if (!ref || !ref.current) {
            cb(false);
            return;
        }
        const handleScroll = () => {
            const top = ref.current.getBoundingClientRect().top;
            const newState = top === offset || top < offset;
            if (newState !== currentState.current) {
                currentState.current = newState;
                cb(currentState.current);
            }
        };
        document.addEventListener('scroll', handleScroll, true);
        document.addEventListener('touchmove', handleScroll, true);
        return () => {
            document.removeEventListener('scroll', handleScroll, true);
            document.removeEventListener('touchmove', handleScroll, true);
        };
    }, dep ?? []);
};
//# sourceMappingURL=useScrollDetection.js.map